<template>
  <div>
    <div class="dropdown is-small is-right" :class="{ 'is-active': active }" @click="active ? close() : open()">
      <div class="dropdown-trigger">
        <button class="button is-small is-black is-outlined"
                aria-haspopup="true" aria-controls="dropdown-menu"
                :class="{ 'is-active': active }">
          <span>{{ label }}</span>
          <span class="icon is-small"><i class="material-icons">&#xE313;</i></span>
        </button>
      </div>
      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a class="dropdown-item" v-for="(option, index) in options"
             :key="index"
             :class="{ 'is-active' : option.value === value }"
             @click="select(option.value)"
          >{{ option.label }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Ui from 'services/Ui'
  import Dropdown from 'views/mixins/dropdown'

  export default {

    extends: Dropdown,

    props: {
      value: {
        type: [Number, String],
      },

      options: {
        type: Array,
        default() {
          return []
        },
      }
    },

    computed: {
      label () {
        const option = this.options.find(option => option.value === this.value)
        return option
          ? option.label
          : '?'
      }
    },

    methods: {
      select(value) {
        this.$emit('change', value)
        this.$nextTick(this.close.bind(this))
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
